module.exports = __webpack_public_path__ + "img/gallery09.fa1398c1.jpg";